import React from "react"
import { Link, InternalIcon, SurfaceColor, Card } from "@carrotfertility/carotene-core"
import { Link as ReactRouterLink } from "react-router-dom"
import { FormattedMessage, useIntl } from "react-intl"
import { Paths } from "#/utils/Paths"

export function HelpCenterModule({ color = "primary" }: { color?: SurfaceColor }): JSX.Element {
  const intl = useIntl()
  return (
    <Card
      variant="secondary"
      color={color}
      id="home-sidebar-help-center-module"
      title={intl.formatMessage({ defaultMessage: "Get answers to frequently asked questions" })}
      primaryAction={
        <Link component={ReactRouterLink} to={Paths.FAQS} endIcon={<InternalIcon fontSize="small" color="primary" />}>
          <FormattedMessage defaultMessage="Visit Help Center" />
        </Link>
      }
    />
  )
}
